import axios from "axios";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { backendBookartUrl } from "../library/constants";
import { adminValidation } from "../library/service";
import Popup from '../components/Popup';

const ProductDetailsUpload = () => {
  const [fileName, setFileName] = useState(null);
  const [attachment, setAttachment] = useState(null);
  const [loader, setLoader] = useState(false);
  const [sentToBackend, setSentToBackend] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [admin, setAdmin] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [popupTitle, setPopupTitle] = useState('');
  const [popupMessage, setPopupMessage] = useState('');

  const navigate = useNavigate();

  useEffect(() => {
    authUser();
    adminAuth();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const authUser = async () => {
    const token = window.sessionStorage.getItem("JWTtoken");

    if (!token) {
      navigate("/");
      return;
    }
  };



  const adminAuth = async () => {
    const authorized = await adminValidation();
    console.log("authorised:", authorized);
    if (!authorized) {
      // Redirect to login page if the token has expired
      navigate('/');
    } else if (authorized && authorized.data.is_admin) {
      setAdmin(true);
    } else {
      navigate("/unAuthorized");
    }
  };


  const handleChange = (event) => {
    let uploadedFile = event.target.files[0];
    let fileName = uploadedFile.name;

    setFileName(fileName);
    setAttachment(uploadedFile);
    setDisabled(false);
  };

  const sendToBackend = (e) => {
    e.preventDefault();
    const token = window.sessionStorage.getItem("JWTtoken");
    let formData = new FormData();
    formData.append("files", attachment);
    setLoader(true);
    setSentToBackend(true);
    var config = {
      method: "post",
      url: `${backendBookartUrl}productUpload`,
      headers: {
        "Authorization": `Bearer ${token}`,
      },
      data: formData,
    };

    axios(config)
      .then((response) => {
        let status = response.status;
        console.log("upload response", response);
        if (status === 200) {
          handleShowPopup('Upload Product', response.data.message);
        } else {
          handleShowPopup('Upload Product', response.data.message);
        }
      })
      .catch((error) => {
        handleShowPopup('Upload Product', "Failed to upload product details. Retry Again!!!");
        console.log(error);
      });
  };

  const handleShowPopup = (title, message) => {
    setPopupTitle(title);
    setPopupMessage(message);
    setLoader(false);
    setShowPopup(true);
  };

  const handleClosePopup = () => {
    setSentToBackend(false);
    setFileName(null);
    setAttachment(null);
    setDisabled(true);
    setShowPopup(false);
  };

  if (!admin) {
    return <div></div>;
  } else {
    return (
      <React.Fragment>
        <div className="container min-height60">
          {/* <MainHeader />
        <div className="container back-home">
          <Link to="/admin/product">
            <button className="es-link colored font-16" type="submit">
              <svg viewBox="0 0 54 128" height="16" width="11">
                <path d="M1 61l45-45 7 7-38 38 38 38-7 7z"></path>
              </svg>
              &nbsp;Back To Product Page
            </button>
          </Link>
        </div> */}
          {sentToBackend ? (
            <div>
              {loader ? (
                <div
                  className="es-progress-indicator container user-admin"
                  role="progressbar"
                >
                  <div></div>
                </div>
              ) : (
                <Popup
                  title={popupTitle}
                  message={popupMessage}
                  show={showPopup}
                  handleClose={handleClosePopup}
                />
              )}
            </div>
          ) : (
            <div className="container user-admin">
              <h1> Product Details </h1>
              <h6>Note: Only .xlsx file is allowed </h6>
              <form onSubmit={sendToBackend}>
                <p>
                  <label
                    htmlFor="upload-user"
                    className="pointer es-button secondary upload-label"
                  >
                    <span>Choose File</span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 112 128"
                      height="24"
                      width="21"
                    >
                      <path d="M21 10v10h80v60.953L74.06 108H31V86H21v32h57.216L111 85.082V10zm72 70V70H63v30h10V80zm-72-2h10V47.756c8 7.73 5.6 5.886 13.052 13.712l7.243-6.894-25.293-26.577L.707 54.574l7.243 6.894C17.28 51.662 17 52.828 21 47.756z" />
                    </svg>
                  </label>
                  <input
                    className="pointer"
                    id="upload-user"
                    type="file"
                    name="file"
                    autoComplete="off"
                    accept=".xlsx"
                    required
                    onChange={handleChange}
                  />
                </p>
                <p id="file_name_upload">{fileName}</p>
                <p>
                  <button
                    className="es-button primary"
                    type="submit"
                    disabled={disabled}
                  >
                    Submit
                  </button>
                </p>
              </form>
            </div>
          )}
          {/* <Footer /> */}
        </div>
      </React.Fragment>
    );
  }
};

export default ProductDetailsUpload;